import React, { Component } from 'react';
import {RegWrapper} from './RegWrapper.js';
import axios from 'axios';
import Loading from './img/loading.gif';
import validator from 'validator';
import {Loader} from './Loader.js';

import {SocialAuth} from './SocialAuth.js';

/*sendRegister = (e) => {
    e.preventDefault();
    
    axios
    .post(DOMAIN + '/user/create/', {
        'username' : $('#name').val(),
        'email' : $('#email').val(),
        'password' : $('#pass').val(),
    }, )
    .then(res => {
        console.log(res.data)
    })
    .catch(err => {
    console.log(err);
    })
    console.log('this.state')
    console.log(this.state)
    this.setState({hasSentRegRequest: true})
    
}*/

const RegRequestNotSent =  (props) => {
    
    return <>
        
        <div><h1>Регистрация</h1></div>
          <Loader loader={props.isSending} />
          {/*<SocialAuth />*/}
          <div className="uk-margin">
              <input className={
                  props.emailError === null 
                  ?
                  "uk-input uk-form-width-large uk-form-large uk-background-muted "  
                  :
                  "uk-input uk-form-width-large uk-form-large uk-background-muted error_input"  
              } 
              type="text" onChange={e => props.updateEmailValue(e)}  placeholder="Email*" value={props.email} />
              <div className='input_error'>{props.emailError}</div>          
          </div>
          <div className="uk-margin">
              <input className={
                  props.passwordError === null 
                  ?
                  "uk-input uk-form-width-large uk-form-large uk-background-muted "  
                  :
                  "uk-input uk-form-width-large uk-form-large uk-background-muted error_input"  
              } 
              type="password" onChange={e => props.updatePasswordValue(e)}
               value={props.password}  placeholder="Пароль*"/>
               <div className='input_error'>{props.passwordError}</div>  
          </div>
          <div className="main-left-bottom">
              <div className="uk-flex">
                  <div><p>Уже есть аккаунт ?</p></div>
                  <div style={{fontWeight: 'bold', marginLeft: '10px'}}><a href='/auth'>Войти</a></div>
              </div>
              <div className="uk-flex">
                  <div>
                      <input onChange={e => props.updateChecked(e)} checked={props.agreed} className="uk-checkbox" type="checkbox" />
                  
                  </div>
                  <div className="uk-text-left uk-margin-small-left"><p>Регистрируясь в сервисе вы соглашаетесь
                      с политикой конфиденциальности 
                      и условиями пользования</p></div>
              </div>
              <button onClick={e => props.SendRegisterRequest(e)} 
              className="btn1">Зарегистрироваться</button>
          </div>

    </>
}
export class Reg extends Component {
    
    state = {
        email :'',
        password : '',
        agreed : false,
        isSending : false,
        hasSentRegRequest : false,
        emailError: null,
        passwordError: null,
        errorMsg: null,
        showErrorMsg: false 
    }

    constructor(props) {
        super(props)
        this.props = props 
    }

    updateEmailValue = (e) => {
        const updatedInputValue = e.target.value;
        // ...
        
        this.setState((prevState) => {
             return  {
                    email : updatedInputValue,
                    emailError: null
                };
        }, () =>  {
            
        })
    
    }

    updatePasswordValue = (e) => {
        
        const updatedInputValue = e.target.value;        
        this.setState((prevState) => {
             return  {
                    password : updatedInputValue,
                    passwordError: null 
                };
        }, () =>  {
            
        })

    }

    updateChecked = (e) => {

        this.setState((prevState) => {
            return  {
                agreed : !prevState.agreed
               
               };
       }, () =>  {
           
       })


    }

    msgTimer = 2000
    
    /* doShowSuccessMsg = (e) => {
        this.setState((prevState) => {
            return  {
                agreed : !prevState.agreed
               
               };
        })
        setTimeout(() => { 
          setShowSucessMsg(false)
        }, this.msgTimer)
      }
    */
    doShowErrorMsg  ( msg) {
        // setShowErrorMsg(true)
        
        this.setState((prevState) => {
            return  {
                ...prevState,
                isSending : false,
                  errorMsg : msg,
                  showErrorMsg : true
               };
        })
        setTimeout(() => { 
            this.setState((prevState) => {
                return  {
                    ...prevState,
                    isSending : false,
                    errorMsg : null,
                    showErrorMsg : !true
                   };
            })
           
        }, this.msgTimer)
    }


    SendRegisterRequest = (e) => {
        e.preventDefault()
        var emailError = null
        if ( !validator.isEmail(this.state.email) ) {
            emailError =  "Введите корректный email"
        }

        var passwordError = null
        if ( !validator.isStrongPassword(this.state.password, {
            minLength: 8,  minNumbers: 0, minSymbols: 0, minLowercase: 0, minUppercase: 0
          }) ) {
            passwordError =  "Пароль должен содержать не менее 8 символов"
        }
        
        
        if (emailError !== null || passwordError !== null) {

            this.setState((prevState) => {
                return  {
                    isSending : false,
                    emailError : emailError,
                    passwordError : passwordError
                   };
           }, () =>  {
               
           })

           return
        }
        
        if (this.state.agreed) {

            e.preventDefault();
            this.setState({isSending : true})
            var qs = require('qs');
            var utm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).utm
            
            if (!utm) {
                utm = 'empty'
            }
            
            axios
            .post(process.env.REACT_APP_BACKEND_SERVER+'/CreateUserBeforeEmailConfirmed/', {
                
                'email' : this.state.email,
                'password' : this.state.password,
                'utm' : utm
            }, )
            .then(res => {
                if (res.data.status == 'ok') {
                    this.setState({hasSentRegRequest: true, isSending:false})
                }
                else {
                    this.setState({isSending:false}, () => {
                        this.doShowErrorMsg( res.data.text )
                    })
                }
            })
            .catch(err => {
            console.log(err);
            })
           
        }
        else {
            this.doShowErrorMsg( "Поставьте галочку" )
        }
        
        
        
        

    }

    render() {
        return (
            
            <RegWrapper showErrorMsg={this.state.showErrorMsg}
            errorMsg={this.state.errorMsg}>
            { this.state.hasSentRegRequest ? 
            <div>
                <h1>
                    Проверьте email для подтверждения регистрации. 
                    Письмо могло попасть в папку спам. 
                    Если письмо не пришло в течение 1 минуты, 
                     <a href={process.env.REACT_APP_SUPPORT_LINK}> напишите в тех. поддержку </a>
                </h1>
            </div>
            :
            <RegRequestNotSent
            isSending={this.state.isSending}
            passwordError = {this.state.passwordError}
            emailError = {this.state.emailError} 
            updateEmailValue={this.updateEmailValue} 
            updatePasswordValue={this.updatePasswordValue} 
            password={this.state.password}
             email={this.state.email} updateChecked={this.updateChecked}
              agreed={this.state.agreed} 
              SendRegisterRequest={this.SendRegisterRequest}/> }
            
      
        </RegWrapper>  

        )
    }

}
